/*
 * Define State Variable
 *
 */
export const UPDATE_USER_LIST = "UPDATE_USER_LIST";